const searchProduct = () => {

    var modalMask = document.getElementById('modalMask');

    document.addEventListener('DOMContentLoaded', function () {
        var searchBtn = document.getElementById('btnSearch');
        searchBtn.onclick = function (event) {
            openModal('productSearch-modal', event.target);
        }

        var close = document.getElementsByClassName('close-link');

        for (var i = 0; i < close.length; i++) {
            var cls = close[i] as HTMLElement;
            cls.onclick = function () {
                closeAllModals();
            }
        }

        var submitCancel = document.getElementsByClassName('cancelSpecialInput')[0] as HTMLElement;

        submitCancel.onclick = function () {
            closeModal('productSearch-modal');
        }

        var submit = document.getElementById('ibtnSubmitSpecialInput') as HTMLElement;

        submit.onclick = function () {
            var txt = document.getElementById('txtPriceId') as HTMLInputElement;
            txt.value = (document.getElementById('hdnProductId') as HTMLInputElement).value;
            closeModal('productSearch-modal');
        }
    });

    function openModal(modalID, btn) {
        var modal = document.getElementById(modalID);
        modal.style.display = "block";
        modalMask.style.display = "block";
        modalMask.onclick = function () {
            closeAllModals();
        }

        var elm = document.getElementsByClassName('new-factor-search');
        if (elm.length > 0) {
            (elm[0] as HTMLElement).innerHTML = '';
            (elm[0] as HTMLElement).classList.remove("display-none");
        }

    }

    function closeModal(modalID) {

        var elm = document.getElementsByClassName('new-factor-search');
        if (elm.length>0) {
            (elm[0] as HTMLElement).classList.add("display-none");
        }

        var modal = document.getElementById(modalID);
        modal.style.display = "none";
        modalMask.style.display = "none";
    }

    function closeAllModals() {
        closeModal('productSearch-modal');
    }

};

export {
    searchProduct
};